import { gql } from '@apollo/client';
import { PartnerContactInfo } from '../fragments';

export default gql`
  mutation destroyPartnerContact(
    $input: PartnerContactDestroyInput!
  ) {
    destroyPartnerContact(input: $input) {
      clientMutationId
      partnerContact {
        ...PartnerContactInfo

      }
    }
  }
  ${PartnerContactInfo}
`;
